import { io } from "socket.io-client"
const connectionOptions = {
  autoConnect: false, //autoConnect is set to false so the connection is not established right away. We will manually call socket.connect() later, once the user has logged in
  reconnectionAttempts: 10000,
  transports: ["websocket"],
}
const URL = process.env.REACT_APP_SOCKET_URL || process.env.REACT_APP_API_URL
const socket = io(URL, connectionOptions)

export default socket